import { SidebarContext } from '@/providers/SidebarProvider';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Button } from '@music-vine/cadence/ui';
import { TopBarContentSearchButton } from './TopBarContentSearchButton';
import { Menu, X } from '@music-vine/cadence/icons';
interface TopBarContentBaseProps {
  children: React.ReactNode;
}
export const TopBarContentBase = ({
  children
}: TopBarContentBaseProps) => {
  const {
    isSidebarToggled,
    toggleSidebar
  } = useContext(SidebarContext);
  const router = useRouter();
  const isPricingPage = router.pathname.startsWith('/pricing');
  return <nav className={clsx('header-right', isSidebarToggled ? 'sidebar-open' : '', 'flex h-10 items-center justify-end gap-2', isPricingPage && '[@media(min-width:600px)]:hidden')} data-sentry-component="TopBarContentBase" data-sentry-source-file="TopBarContentBase.tsx">
      {children}
      <TopBarContentSearchButton data-sentry-element="TopBarContentSearchButton" data-sentry-source-file="TopBarContentBase.tsx" />
      <Button aria-controls="navbarSupportedContent" aria-expanded="false" borderRadius="full" className="headerFixed:hidden" data-target="#navbarSupportedContent" data-toggle="collapse" icon onClick={() => {
      toggleSidebar();
    }} size="default" variant="transparent" data-sentry-element="Button" data-sentry-source-file="TopBarContentBase.tsx">
        {isSidebarToggled ? <X className="size-4" /> : <Menu className="size-4" />}
      </Button>
    </nav>;
};